<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import { type DateValue, getLocalTimeZone } from '@internationalized/date'
import { CalendarIcon } from 'mdi-vue3'
import type { HTMLAttributes } from 'vue'
import { useI18n } from 'vue-i18n'

import { cn } from '../../../lib/utils'
import { Calendar } from '../calendar'
import { Popover, PopoverContent, PopoverTrigger } from '../popover'

const properties = defineProps<{
  class?: HTMLAttributes['class']
  disabled?: boolean
}>()

const model = defineModel<DateValue | undefined>()

const { d } = useI18n()
</script>

<template>
  <Popover>
    <PopoverTrigger as-child>
      <button class="w-full">
        <div class="atabix-date-input-wrap">
          <div :class="cn('atabix-date-input', { 'atabix-date-input--placeholder': !model }, properties.class)">
            {{ model ? d(model.toDate(getLocalTimeZone()), 'short') : 'dd-mm-yy' }}
          </div>
          <div class="atabix-date-input-actions">
            <div class="atabix-date-input-actions__clear">
              <CalendarIcon />
            </div>
          </div>
        </div>
      </button>
    </PopoverTrigger>
    <PopoverContent class="w-auto p-0">
      <Calendar v-model="model" initial-focus />
    </PopoverContent>
  </Popover>
</template>

<style lang="scss" scoped>
.atabix-date-input-wrap {
  @apply relative;
}
.atabix-date-input {
  @apply flex;
  @apply h-10;
  @apply w-full;
  @apply rounded-md;
  @apply border;
  @apply border-border;
  @apply bg-background;
  @apply px-3;
  @apply py-2;
  @apply text-base;
  @apply ring-offset-background;
  @apply file:border-0;
  @apply file:bg-transparent;
  @apply file:text-base;
  @apply file:font-medium;
  @apply placeholder:text-foreground-placeholder;
  @apply focus-visible:outline-none;
  @apply focus-visible:ring-2;
  @apply focus-visible:ring-background-selected;
  @apply focus-visible:ring-offset-2;
  @apply disabled:cursor-not-allowed;
  @apply disabled:bg-background-disabled;
  @apply cursor-pointer;
}
.atabix-date-input--placeholder {
  @apply text-form-foreground-val-placeholder;
}
.atabix-date-input--clearable {
  @apply pr-20;
}
.atabix-date-input-actions {
  @apply absolute;
  @apply right-3;
  @apply top-0;
  @apply h-full;
  @apply flex;
  @apply items-center;
}
.atabix-date-input-actions__clear {
  @apply size-5;
  @apply pointer-events-none;
}
</style>
